import "./ContentIndustryCrawlVTwoStyles.scss";
const contentIndustryCrawlVTwo = () => {
    //
};
export { contentIndustryCrawlVTwo };
